import React, { useState } from 'react'
import { MdModeEditOutline } from "react-icons/md";
import AdminEditProduct from './AdminEditProduct';
import displayINRCurrency from '../helpers/displayCurrency';
import { MdDelete } from 'react-icons/md';
import SummaryApi from '../common';
import { toast } from 'react-toastify';
import defaultImage from '../assest/DAWACO_Icon.png'

const AdminProductCard = ({
    userType,
    data,
    fetchdata
}) => {
    const [editProduct,setEditProduct] = useState(false)
    const [confirmationVisible, setConfirmationVisible] = useState(false);
    const [productToDelete, setProductToDelete] = useState(null);

    const handleDeleteClick = (product) => {
      setProductToDelete(product);
      setConfirmationVisible(true);
  };

  const deleteFromCart = async (id) => {

    const response = await fetch(SummaryApi.deleteFromCart.url, {
      method: SummaryApi.deleteFromCart.method,
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        productId: id,
      }),
    });

    const responseData = await response.json();

    

};

    const handleDelete = async (id,userType) => {
      
      try {
          await deleteFromCart(id)
         
          const response = await fetch(SummaryApi.deleteProduct.url, {
            method: SummaryApi.deleteProduct.method,
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: id,
              type:userType,
            }),
          });

          const responseData = await response.json();

          if (responseData.success) {
              toast.success('تم حذف المنتج بنجاح');
              setConfirmationVisible(false);
              fetchdata();
          } else {
              toast.error('فشل في حذف المنتج');
          }
      } catch (error) {
          toast.error('حدث خطأ أثناء حذف المنتج');
      }
  };

  return (
    <div className='bg-white p-4 rounded '>
       <div className='w-40'>
            <div className='w-32 h-32 flex justify-center items-center'>
              <img src={data?.productImage[0] || defaultImage}  className='mx-auto object-fill h-full'/>   
            </div> 
            <h1 className='text-ellipsis line-clamp-2'>{data?.productName}</h1>

            <div>
                <p className='font-semibold'>
                  { displayINRCurrency(data?.sellingPrice > 0 ? data?.sellingPrice : data?.price) }
                </p>

                {/* Buttons for Delete and Edit */}
                <div className='flex relative'>
                    {/* Delete Button */}
                    <div className='right-2 p-2 bg-red-100 hover:bg-red-800 rounded-full hover:text-white cursor-pointer' 
                         onClick={() => handleDeleteClick(data)}>
                        <MdDelete />
                    </div>

                    {/* Edit Button */}
                    <div className='absolute right-20 p-2 bg-blue-100 hover:bg-blue-800 rounded-full hover:text-white cursor-pointer' 
                         onClick={() => setEditProduct(true)}>
                        <MdModeEditOutline />
                    </div>
                </div>
            </div>
       </div>

      
        


{/* Modal for Editing Product */}
{ editProduct&& (
                <div className='fixed inset bg-black bg-opacity-50 flex items-center justify-center z-50'>
                    <div className='bg-white p-8 rounded-lg shadow-lg w-full max-w-3xl relative'>
                        <AdminEditProduct userType= {userType} productData={data} onClose={() => setEditProduct(false)} fetchdata={fetchdata} condition={false} />
                    </div>
                </div>
            )}


        {/* Confirmation Dialog */}
        {confirmationVisible && (
            <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50'>
                <div className='bg-white p-8 rounded-lg shadow-lg w-full max-w-md relative'>
                    <h3 className='text-lg font-semibold mb-4'> ؟ {productToDelete?.productName}هل أنت متأكد أنك تريد حذف      </h3>
                    <div className='flex gap-4'>
                        <button className='bg-red-500 text-white px-4 py-2 rounded' onClick={() => handleDelete(productToDelete._id,userType)}>نعم</button>
                        <button className='bg-gray-300 px-4 py-2 rounded' onClick={() => setConfirmationVisible(false)}>لا</button>
                    </div>
                    {/* Optional Close Button */}
                    <button 
                        className='absolute top-2 right-2 text-gray-500 hover:text-gray-700'
                        onClick={() => setConfirmationVisible(false)}
                    >
                        &times;
                    </button>
                </div>
            </div>
        )}
    </div>
  )
}

export default AdminProductCard;
